import { primaryButton } from "../../../components/ui/buttonStyles.js";
import { formatRowCount } from "../../../logic/services/reportBuilderSummary.js";
import { rbInputStyle, rbSectionHint } from "../reportBuilderTheme.js";

export function SaveStep({ reportName, onNameChange, onSave, saving, saveSuccess, saveError, stepError, estimate, c, A, dark }) {
  return (
    <div style={{ maxWidth: 480 }}>
      <p style={rbSectionHint(c)}>Name your report definition. Saved reports can be scheduled or shared with your team.</p>
      <label style={{ display: "block", marginBottom: 12 }}>
        <span style={{ display: "block", fontSize: 12, fontWeight: 600, color: c.mid, marginBottom: 6 }}>Report name</span>
        <input
          value={reportName}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Weekly fuel efficiency by city"
          style={rbInputStyle(c, false, { error: Boolean(stepError || saveError) })}
        />
      </label>
      {(stepError || saveError) ? (
        <p style={{ margin: "0 0 12px", fontSize: 12, fontWeight: 600, color: "#EF4444" }}>{stepError || saveError}</p>
      ) : null}
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        style={{
          ...primaryButton(A, { dark }),
          opacity: saving ? 0.7 : 1,
          cursor: saving ? "wait" : "pointer",
        }}
      >
        {saving ? "Saving…" : "Save report"}
      </button>
      {saveSuccess && estimate ? (
        <div
          style={{
            marginTop: 14,
            padding: "12px 14px",
            borderRadius: 10,
            background: dark ? "rgba(34,197,94,.12)" : "rgba(34,197,94,.08)",
            border: "1px solid rgba(34,197,94,.35)",
            fontSize: 12,
            color: dark ? "#86efac" : "#15803d",
            lineHeight: 1.6,
          }}
        >
          Report saved successfully · {formatRowCount(estimate.rows)} rows · {estimate.scan} scan · {estimate.runtimeSec}s runtime
        </div>
      ) : null}
    </div>
  );
}
